import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ColumnLeftSidebarComponent } from './blog-grid/column-left-sidebar/column-left-sidebar.component';

import { DetailGalleryComponent } from './blog-detail/detail-gallery/detail-gallery.component';
import { DetailVideoComponent } from './blog-detail/detail-video/detail-video.component';
import { DetailLeftSidebarComponent } from './blog-detail/detail-left-sidebar/detail-left-sidebar.component';
import { BlogComponent } from './blog.component';
import { BlogDetailResolveService } from '../resolves/blog-detail-resolve.service';
import { LanguageResolveService } from '../resolves/language-resolve.service';

const routes: Routes = [
  {
    path: '',
    component: BlogComponent,
    children: [
      {
        path: '',
        component: ColumnLeftSidebarComponent,
        resolve: {
          lang: LanguageResolveService
        }
      },
      {
        path: ':code',
        component: DetailLeftSidebarComponent ,
        resolve: { lang: LanguageResolveService, blog: BlogDetailResolveService, },
      },
      // {
      //   path: 'blog-detail/detail-gallery',
      //   component: DetailGalleryComponent,
      //   data: {
      //     title: "BLOG WITH Gallery",
      //     breadcrumb: "Blog Details / Detail With Gallery"
      //   }
      // },
      // {
      //   path: 'blog-detail/detail-video',
      //   component: DetailVideoComponent,
      //   data: {
      //     title: "BLOG WITH Video",
      //     breadcrumb: "Blog Details / Detail With Video"
      //   }
      // },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BlogRoutingModule { }
